import React from 'react';
import * as Routes from '@/modules/routes';
import eyeIcon from 'images/icons/eye.svg';
import pencilBubbleIcon from 'images/icons/pencil_bubble.svg';
import { slideGroupInitialValues } from '../utils';
import useLessonOverviewContext from '../../useLessonOverviewContext';
import FullWidthCard from './FullWidthCard';

const ICON_MAP = {
  eye: eyeIcon,
  pencil: pencilBubbleIcon,
};

interface SlideGroupCardProps {
  slideGroup: any;
  icon: 'eye' | 'pencil';
}

const SlideGroupCard = ({ icon, slideGroup }: SlideGroupCardProps) => {
  const lessonId = useLessonOverviewContext(state => state.lessonId);
  const programId = useLessonOverviewContext(state => state.programId);
  const unitColor = useLessonOverviewContext(state => state.unitColor);

  const presentPath = Routes.present_mode_shared_slide_show_path(slideGroup.slideShowId ?? slideGroup.slide_show_id, {
    from: 'lesson',
    parent_id: lessonId,
    parent_type: 'Lesson',
    program_id: programId,
    starting_slide: slideGroup.firstSlideId,
  });

  const initialValues = slideGroupInitialValues(slideGroup);

  return (
    <FullWidthCard
      borderLeft
      openInNewWindow
      iconSrc={ICON_MAP[icon]}
      initialValues={initialValues}
      isAssigned={slideGroup.isAssigned}
      pacing={slideGroup.pacing}
      page={slideGroup.page}
      presentPath={presentPath}
      title={slideGroup.title}
      unitColor={unitColor}
    />
  );
};

export default SlideGroupCard;
